import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material"; // Import ThemeProvider and CssBaseline
import { createTheme } from "@mui/material/styles"; // Import createTheme
import { useSelector } from "react-redux"; // Import useSelector for accessing Redux state
import PrivateRoute from "state/PrivateRoute"; // Ensure the path is correct
import Layout from "scene/Layout"; // Your layout component
import Mr from "scene/Mr"; // Protected component
import Sm from "scene/Sm"; // Protected component
import Admin from "scene/Admin"; // Protected component
import LoginPage from "scene/Login"; // Login component
import { themeSettings } from "theme"; // Import your theme settings if you have a separate file
import RoleBasedRoute from "state/RoleBasedRoute";  // No curly braces
import DailyWise from "scene/DailyWise";
import RmDetails from "scene/Amdetails";
import PobImagePreviewModal from "scene/imagepobpreview";
import DailyWisePob from "scene/Dailywisepob";
import SrSm from "scene/SRSM";
import PreviewDailyData from "scene/PreviewDailyData";
import Am from "scene/Am";


import ImagePreviewModal from "scene/AdminPage";

function App() {
  const mode = useSelector((state) => state.global.mode); // Get the current theme mode from Redux
  const theme = createTheme(themeSettings(mode)); // Create a theme based on the mode

  return (
    <ThemeProvider theme={theme}> {/* Wrap your application with ThemeProvider */}
      <CssBaseline /> {/* Normalize styles */}
      <BrowserRouter>
        <Routes>
          <Route path="/LoginPage" element={<LoginPage />} />
          <Route path="/" element={<Navigate to="/LoginPage" replace />} />
          {/* Protected Routes */}
          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>

              {/* MR Route */}
              <Route element={<RoleBasedRoute allowedRoles={["MR"]} />}>
                <Route path="/Mr" element={<Mr />} />
              </Route>

              {/* AM Route */}
              <Route element={<RoleBasedRoute allowedRoles={["AM"]} />}>
                <Route path="/Am" element={<Am />} />
              </Route>

              {/* SM Route */}
              <Route element={<RoleBasedRoute allowedRoles={["SM","SRSM"]} />}>
                <Route path="/Sm" element={<Sm />} />
                <Route path="/PreviewDailyData" element={<PreviewDailyData />} />

              </Route>

              {/* SRSM Route */}
              <Route element={<RoleBasedRoute allowedRoles={["SRSM"]} />}>
                <Route path="/SrSm" element={<SrSm />} />
              </Route>

              {/* Admin Route */}
              <Route element={<RoleBasedRoute allowedRoles={["Admin"]} />}>
                <Route path="/Admin" element={<Admin />} />
                <Route path="/rm-details" element={<RmDetails />} />
                <Route path="/imagePreviewModal" element={<ImagePreviewModal />} />
                <Route path="/DailyWise" element={<DailyWise />} />
                <Route path="/PobImagePreviewModal" element={<PobImagePreviewModal />} />
                <Route path="/DailyWisePob" element={<DailyWisePob />} />

              </Route>

            </Route>
          </Route>

        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;